














import { VueConstructor } from 'vue';
import { Component, Vue } from 'vue-property-decorator';
import Norway from '@/components/Flag/Norway.vue';
import UnitedKingdom from '@/components/Flag/UnitedKingdom.vue';
import Locale from '@/utils/locale';
import TabTitle from '@/utils/tabtitle';

interface ILanguage {
  code: string;
  component: VueConstructor<Norway | UnitedKingdom>;
}

@Component
export default class ChangeLanguage extends Vue {
  public languages: ILanguage[] = [
    { code: 'nb', component: Norway },
    { code: 'en', component: UnitedKingdom },
  ];

  public setLang(language: string) {
    Locale.set(language);
    this.$i18n.locale = language;
    this.$dayjs.locale(language);
    TabTitle.refresh();
  }
}
